function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (function (_ref) {
  var colors = _ref.colors,
      mediaQueries = _ref.mediaQueries;
  return {
    component: {
      color: colors.darkGray,
      margin: 'auto',
      position: 'relative',
      textAlign: 'center',
      '& h1': {
        display: 'inline-block',
        fontSize: '38px',
        maxWidth: '480px'
      },
      '& hr': {
        borderTop: "1px solid ".concat(colors.borderGray),
        margin: '30px 0'
      },
      '& .desktop': _defineProperty({
        // show hide for viewpoints
        display: 'none'
      }, mediaQueries.breakpointLarge, {
        display: 'inline-block'
      }),
      '& .mobile': _defineProperty({
        display: 'inline-block'
      }, mediaQueries.breakpointLarge, {
        display: 'none'
      })
    },
    main: {
      background: 'none',
      margin: 'auto',
      maxWidth: '640px'
    },
    container: _defineProperty({
      background: 'transparent',
      borderRadius: '0',
      boxShadow: 'none',
      float: 'left',
      textAlign: 'center',
      width: '100%',
      '& input': {
        backgroundColor: colors.background
      },
      '& button': {
        margin: '15px 0 0'
      }
    }, mediaQueries.breakpointLarge, {
      background: colors.background,
      borderRadius: '5px',
      boxShadow: '0 1px 1px 0 rgba(0,0,0,0.04)',
      padding: '40px 40px 50px',
      width: '100%'
    }),
    backLink: {
      clear: 'both',
      padding: '35px 0 70px'
    }
  };
});